import React, { Component } from "react";
import { Container, Form, Button, Nav, NavItem, NavLink } from "reactstrap";
import "./randomtest.css";
import { library, counter } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-solid-svg-icons";
import { sample } from "lodash";
library.add(faClock);

class Randomtest13_2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      count: 20
    };
  }

  render() {
    const { count } = this.state;
    let box = ["/randomtest22", "/randomtest22_2"];
    let box2 = ["/randomtest14", "/randomtest14_2"];
    return (
      <div>
        <Container className="comming">
          <Form className="boxrandomtest">
            <h1 className="textrandomtest">แบบทดสอบวัดระดับ</h1>
            <h1 className="cdtimer">
              <FontAwesomeIcon icon="clock" /> {count}
            </h1>
            <Form className="Q1">
              <h3 className="textStudy2">
                2. ปฏิทิน เกิดขึ้นเพราะเหตุผลในข้อใด
              </h3>{" "}
              <br></br>
              <Button className="rdTest1" href={sample(box)}>
                <h5>ก. การบอกกล่าวของคนไม่ทั่วถึง</h5>
              </Button>
              <br></br>
              <Button className="rdTest1" href={sample(box2)}>
                <h5>ข. ใช้ดูวันและเวลาของแพทย์</h5>
              </Button>
              <br></br>
              <Button className="rdTest1" href={sample(box2)}>
                <h5>ค. กษัตริย์ต้องการเป็นที่ระลึก</h5>
              </Button>
            </Form>

            <Button className="rdTestbt1" href="/randomtest14">
              <h5>ข้ามข้อนี้</h5>
            </Button>
            <br></br>
            <h3 className="ranknumberB">1</h3>
            <h3 className="ranknumberW1">2</h3>
            <h3 className="ranknumberW1">3</h3>
            <h3 className="ranknumberW1">4</h3>
            <h3 className="ranknumberW1">5</h3>
          </Form>
        </Container>

        <div className="footer text-footer">
          <p>Surasak Noorurk</p>
          <p> Project 5935512072 Computer Engineering</p>
          <NavLink href="https://surasak783023869.wordpress.com/">
            ช่องทางการติดต่อ
          </NavLink>
        </div>
      </div>
    );
  }

  componentDidMount() {
    const { startCount } = this.props;
    this.setState({
      count: startCount
    });
    this.doIntervalChange();
  }

  componentDidMount() {
    this.myInterval = setInterval(() => {
      this.setState(prevState => {
        const newCount = prevState.count - 1;
        if (newCount == -1) {
          clearInterval(this.myInterval);
          this.props.history.push("/randomtest14");
        }
        return { count: newCount };
      });
    }, 1000);
  }

  componentWillMount() {
    clearInterval(this.myInterval);
  }
}

export default Randomtest13_2;
